export const resources = {
  'pt-BR': {
    translation: {
      subscription: {
        toasts: {
          loadPlansError: 'Não foi possível carregar os planos de assinatura.',
          paymentConfirmed: 'Pagamento confirmado com sucesso!',
          paymentReleased: 'Pagamento confirmado! Seu acesso foi liberado.',
          paymentReturnReceived:
            'Recebemos seu retorno de pagamento. Atualize a página em alguns segundos.',
          checkoutStartError: 'Não foi possível iniciar o checkout.',
          openPortalError: 'Não foi possível abrir o portal de assinatura.',
        },
        browserBlockedPrompt:
          'Seu navegador bloqueou a nova guia. Abra este link manualmente:',
        successScreen: {
          title: 'Pagamento confirmado!',
          syncing: 'Estamos liberando seu acesso...',
          redirecting: 'Seu plano foi ativado com sucesso. Redirecionando você para o dashboard.',
        },
        header: {
          partnerContactTitle: 'Fale com seu parceiro para liberar o acesso',
          paymentPendingTitle: 'Seu acesso está temporariamente pausado',
          expiredTitle: 'Sua avaliação expirou',
          defaultTitle: 'Escolha o plano ideal para o seu negócio',
          partnerContactDescription:
            'Este ambiente é gerenciado por parceiro. A contratação/renovação da licença deve ser feita pelo parceiro responsável.',
          paymentPendingDescription:
            'Identificamos uma pendência no pagamento da assinatura. Regularize agora para reativar imediatamente o sistema.',
          trialDescription:
            'Você tem {{count}} dias restantes no seu período de avaliação de 8 dias.',
          defaultDescription: 'Desbloqueie o sistema e gerencie sua assinatura com a Stripe.',
        },
        partnerContact: {
          title: 'Licença gerenciada por parceiro',
          description:
            'Entre em contato com o parceiro para contratar ou regularizar a licença deste ambiente.',
          partnerLabel: 'Parceiro:',
          partnerFallback: 'Parceiro responsável',
          contactLabel: 'Contato:',
          contactFallback: 'Não informado',
          action: 'Entrar em contato com parceiro',
        },
        pendingCard: {
          description: 'Assim que o pagamento for confirmado, seu acesso é liberado automaticamente.',
        },
        activeCard: {
          syncing: 'Confirmando pagamento e liberando seu acesso...',
          active: 'Pagamento confirmado com sucesso! Seu acesso já está ativo.',
        },
        actions: {
          back: 'Voltar',
          backToHome: 'Voltar para tela inicial',
          manageSubscription: 'Gerenciar assinatura',
        },
        partnerManaged: {
          title: 'Assinatura gerenciada por parceiro',
          description:
            'Este ambiente está vinculado a um parceiro. A renovação e cobrança são feitas diretamente pelo parceiro responsável.',
          hidePlansMessage: 'Os planos e preços ficam disponíveis somente para o parceiro responsável por este ambiente.',
          modalTitle: 'Verifique com seu parceiro',
          modalDescription:
            'Este ambiente é atendido por um parceiro. Consulte o parceiro responsável para contratar ou alterar o plano.',
          modalClose: 'Fechar',
        },
        partnerTenantUnavailable: 'Parceiros utilizam o plano de parceiro e não contratam planos por esta tela.',
        plans: {
          loading: 'Carregando planos...',
          empty: 'Nenhum plano configurado. Defina os Price IDs da Stripe no backend.',
          popular: 'Mais Popular',
          currentPlanBadge: 'Plano atual',
          period: '/mês',
          subscribeButton: 'Assinar com Stripe',
          currentPlanButton: 'Seu plano atual',
          upgradeButton: 'Fazer upgrade',
          downgradeNotAvailableButton: 'Plano inferior',
          partnerManagedButton: 'Ver com parceiro',
          addonLockedButton: 'Necessário ter 2 bots',
          addonExtraBot: 'Adiciona 1 bot extra ao seu ambiente',
          addonMonthlyBilling: 'Cobrança mensal por bot adicional',
          addonLockedRequirement:
            'Para contratar 3 bots ou mais, este ambiente precisa ter pelo menos 2 bots ativos primeiro.',
          unlimitedMessages: 'Mensagens ilimitadas',
          bitrixIntegration: 'Integração Bitrix24',
          visualFlowBuilder: 'Editor visual de fluxos',
          includedBots_one: '{{count}} bot incluído',
          includedBots_other: '{{count}} bots incluídos',
        },
        support: {
          prompt: 'Precisa de ajuda para escolher?',
          action: 'Fale com nosso time',
        },
      },
      connections: {
        errors: {
          loadPartnerClients: 'Falha ao carregar clientes do parceiro.',
          reconnectFailed: 'Não foi possível corrigir a conexão.',
          linkClientFailed: 'Falha ao vincular cliente.',
          unlinkClientFailed: 'Falha ao desvincular cliente.',
          openLicensePortalFailed: 'Falha ao abrir gerenciamento da licença.',
          noPlanAvailable: 'Nenhum plano disponível para contratação no momento.',
          contractLicenseFailed: 'Falha ao iniciar contratação da licença.',
          openClientReadOnlyFailed: 'Não foi possível abrir o tenant do cliente em modo leitura.',
          backToPartnerFailed: 'Não foi possível retornar ao painel do parceiro.',
        },
        toasts: {
          reconnectSuccess: 'Conexão corrigida com sucesso.',
          linkClientSuccess: 'Solicitação de vínculo enviada para aceite do cliente.',
          readOnlyEnabled: 'Modo leitura ativado para o tenant do cliente.',
          backToPartnerSuccess: 'Retornou ao painel do parceiro.',
        },
        prompts: {
          blockedNewTabManage:
            'Seu navegador bloqueou a nova guia. Abra este link para gerenciar/cancelar a licença no Stripe:',
          blockedNewTabContract:
            'Seu navegador bloqueou a nova guia. Abra este link para contratar a licença no Stripe:',
        },
        status: {
          active: 'Ativo',
          pending: 'Pendente',
          error: 'Erro',
          disconnected: 'Desconectado',
          trial: 'Trial',
          expired: 'Expirado',
          suspended: 'Suspenso',
          cancelled: 'Cancelado',
        },
        partner: {
          title: 'Área do Parceiro',
          subtitle: 'Gerencie os clientes vinculados ao seu parceiro e acesse o ambiente deles.',
          panelTitle: 'Painel do Parceiro (visualização)',
          panelDescription:
            'Aqui você visualiza os clientes vinculados, acessa o cancelamento de licença e pode entrar no tenant do cliente em modo leitura.',
          domainLabel: 'Domínio do cliente no Bitrix24',
          domainPlaceholder: 'ex: cliente.bitrix24.com',
          linking: 'Vinculando...',
          linkClient: 'Vincular cliente',
          loadingClients: 'Carregando clientes do parceiro...',
          noClientsTitle: 'Nenhum cliente vinculado',
          noClientsDescription:
            'Vincule o domínio Bitrix24 de um cliente para começar a gerenciá-lo.',
          noMainDomain: 'Sem domínio principal detectado',
          plan: 'Plano:',
          stripeStatus: 'Status Stripe:',
          botLimit: 'Limite bots:',
          contactEmail: 'Contato técnico:',
          na: 'n/a',
          customerAlreadyLicensed: 'Cliente já possui licença vigente',
          openStripeCheckout: 'Abrir Stripe para contratar licença',
          selectLicensePlan: 'Escolher licença/plano para este cliente',
          selectLicensePlanModalTitle: 'Escolha a licença para contratação',
          selectLicensePlanModalDescription: 'Selecione o plano para {{client}} antes de abrir o checkout.',
          modalCancel: 'Cancelar',
          modalConfirmPurchase: 'Continuar para pagamento',
          openingCheckout: 'Abrindo checkout...',
          contractLicense: 'Contratar licença',
          openStripePortal: 'Abrir Stripe para gerenciar/cancelar a licença',
          noLicenseToCancel: 'Sem licença vigente para cancelar',
          openingPortal: 'Abrindo portal...',
          cancelLicense: 'Cancelar licença',
          manage: 'Gerenciar',
          managePlan: 'Gerenciar plano',
          managePayment: 'Atualizar pagamento (Stripe)',
          managePaymentHint: 'Abrir o portal Stripe para atualizar o método de pagamento, ver faturas e gerenciar a assinatura',
          enteringReadOnly: 'Entrando...',
          enterReadOnly: 'Entrar (somente leitura)',
          updateContact: 'Atualizar contato',
          updatingContact: 'Atualizando...',
          contactPrompt: 'Informe o e-mail de contato técnico do cliente:',
          contactEmptyError: 'Informe um e-mail de contato válido.',
          contactUpdated: 'E-mail de contato atualizado com sucesso.',
          contactUpdateFailed: 'Falha ao atualizar e-mail de contato do cliente.',
          unlinking: 'Desvinculando...',
          unlink: 'Desvincular',
          actingAsClient: 'Você está visualizando o ambiente de um cliente vinculado.',
          backToPartner: 'Voltar para painel do parceiro',
        },
        defaultView: {
          title: 'Conexões Bitrix24',
          subtitle: 'Gerencie as conexões com seus portais Bitrix24',
          infoTitle: 'Como funciona?',
          infoDescription:
            'As conexões são criadas automaticamente quando você instala o aplicativo em um portal Bitrix24. Cada conexão permite criar bots para aquele portal. Para evitar interrupções, a remoção de conexão não fica disponível para o usuário.',
          noConnectionsTitle: 'Nenhuma conexão encontrada',
          noConnectionsDescription:
            'Instale o aplicativo em um portal Bitrix24 para criar sua primeira conexão.',
          marketplaceButton: 'Ir para Bitrix24 Marketplace',
          lastErrorPrefix: 'Último erro:',
          botsCount_one: '{{count}} bot',
          botsCount_other: '{{count}} bots',
          connectedAt: 'Conectado em {{date}}',
          fixConnection: 'Corrigir conexão',
          renewApp: 'Renovar app',
          botsInConnection: 'Bots nesta conexão:',
        },
      },
      flowBuilder: {
        readOnlyBanner: 'Modo leitura ativo: edição do fluxo desabilitada neste tenant.',
        defaults: {
          save: 'Salvar',
          publish: 'Publicar',
          newFlow: 'Novo Fluxo',
          defaultFlowName: 'Novo Fluxo',
          defaultFlowDescription: 'Criado via Dashboard',
          unsaved: 'Não salvo',
          addNode: 'Adicionar Nó',
        },
        states: {
          error: 'Erro!',
          chooseMode: 'Escolha o modo',
          saved: 'Salvo!',
          saveError: 'Erro ao salvar',
          published: 'Publicado!',
        },
        executionMode: {
          label: 'Modo do bot:',
          freeConversation: 'Conversa livre',
          stepByStep: 'Passo a passo',
          modalTitle: 'Como o bot deve conversar?',
          modalRequiredDescription: 'Escolha um modo para continuar a configuração deste fluxo.',
          modalOptionalDescription: 'Você pode alterar este modo quando quiser.',
          conventionalTitle: '🧭 Passo a passo',
          conventionalDescription: 'O bot segue uma sequência e não reinicia a cada mensagem.',
          continuousTitle: '💬 Conversa livre',
          continuousDescription: 'Cada nova mensagem reinicia no início do fluxo para responder.',
          groupingTitle: 'Agrupamento de mensagens',
          groupingDescription: 'Aguarda novas mensagens por alguns segundos e responde tudo de uma vez.',
          groupingEnableLabel: 'Ativar agrupamento neste fluxo',
          groupingWindowLabel: 'Aguardar por',
          groupingWindowHint: 'Mensagens recebidas nesse intervalo serão respondidas juntas.',
          groupingSeconds: 'segundos',
          functionCallingTitle: 'Function Calling global (IA)',
          functionCallingDescription: 'Ativa ferramentas de CRM para todos os nós de IA deste fluxo que usam OpenAI.',
          functionCallingEnableLabel: 'Ativar function calling neste fluxo',
          functionCallingMaxLabel: 'Máximo de chamadas por execução:',
          functionCallingToolsLabel: 'Ferramentas permitidas',
          functionCallingVariableLabel: 'Salvar execuções em variável (opcional)',
          functionCallingVariablePlaceholder: 'Ex: ai_tool_executions',
          functionCallingVariableHint: 'Se preenchido, salva o log das chamadas para uso em outros nós.',
          close: 'Fechar',
          confirm: 'Confirmar',
        },
        nodeLabels: {
          START: 'Início',
          SEND_MESSAGE: 'Enviar Mensagem',
          SEND_BUTTONS: 'Pergunta',
          WAIT_INPUT: 'Aguardar Entrada',
          CONDITION: 'Condição',
          MESSAGE_TYPE: 'Tipo de Mensagem',
          DELAY: 'Delay',
          AI_RESPONSE: 'IA',
          HTTP_REQUEST: 'Requisição HTTP',
          TRANSFER_TO_OPERATOR: 'Transferir p/ Operador',
          END_SESSION: 'Encerrar Sessão',
          SET_VARIABLE: 'Definir Variável',
          PARSE_JSON: 'Parser JSON',
          ADD_TAG: 'Captura Marketing',
          CREATE_LEAD: 'Criar Lead',
          CREATE_COMPANY: 'Criar Empresa',
          CREATE_CONTACT: 'Criar Contato',
          CREATE_DEAL: 'Criar Negócio',
          GET_CRM_ENTITY: 'Obter CRM',
          UPDATE_CONTACT: 'Editar CRM',
          MOVE_DEAL_STAGE: 'Mover Etapa/Pipeline',
        },
      },
      settings: {
        page: {
          title: 'Configurações',
          subtitle: 'Gerencie as configurações da sua conta',
          readOnlyBanner: 'Modo leitura ativo: alterações em configurações estão desabilitadas neste tenant.',
        },
        tabs: {
          general: 'Geral',
          api: 'Integrações',
          billing: 'Plano & Cobrança',
          notifications: 'Notificações',
          marketing: 'Marketing',
        },
        toasts: {
          invalidEmail: 'Informe um e-mail válido para o responsável técnico.',
          invalidEmailTitle: 'E-mail inválido',
          saveSuccess: 'Configurações salvas com sucesso!',
          savedTitle: 'Salvo',
          saveError: 'Não foi possível salvar as alterações.',
          saveErrorTitle: 'Erro ao salvar',
          testNotificationSuccess: 'Notificação de teste enviada! Verifique o sino do Bitrix24.',
          testNotificationSuccessTitle: 'Sucesso',
          testNotificationErrorTitle: 'Erro ao enviar notificação',
          invalidOpenAiKey: 'A chave deve começar com "sk-"',
          invalidOpenAiKeyTitle: 'Chave inválida',
          openAiKeySaved: 'Chave da OpenAI salva com sucesso!',
          openAiKeyRemoved: 'Chave da OpenAI removida.',
          geminiKeySaved: 'Chave do Gemini salva com sucesso!',
          geminiKeyRemoved: 'Chave do Gemini removida.',
          keyErrorTitle: 'Erro ao salvar chave',
          keyRemoveErrorTitle: 'Erro ao remover chave',
          partnerActivated: 'Conta ativada no programa de parceiros!',
          partnerActivatedTitle: 'Parceiro ativado',
          invalidPartnerCodeTitle: 'Código inválido',
          languageUpdated: 'Idioma atualizado com sucesso!',
          languageTitle: 'Idioma',
          languageUpdateError: 'Não foi possível alterar o idioma.',
        },
        general: {
          accountTitle: 'Informações da Conta',
          accountDescription: 'Informações básicas da sua conta',
          companyName: 'Nome da Empresa',
          technicalEmail: 'E-mail do responsável técnico',
          technicalEmailPlaceholder: 'tecnico@empresa.com',
          technicalEmailHelper: 'Este e-mail é usado como contato técnico de referência.',
          accountStatus: 'Status da Conta',
          statusActive: 'Ativa',
          statusTrial: 'Em Teste',
          statusExpired: 'Expirada',
          statusPending: 'Pendente',
          languageLabel: 'Idioma da plataforma',
          languageHelp: 'A alteração é aplicada imediatamente e salva neste navegador.',
          languagePtBr: 'Português (Brasil)',
          languageEn: 'English',
          saveInfo: 'Salvar Informações',
        },
        partner: {
          title: 'Programa de Parceiros',
          description: 'Ative o modo parceiro para gerenciar clientes vinculados no menu Conexões.',
          alreadyPartner: 'Conta já habilitada como parceiro.',
          codeLabel: 'Código de parceiro',
          codePlaceholder: 'Ex.: PARCEIRO-2026',
          codeHelp: 'Use o código que você recebeu para liberar o painel de parceiro.',
          activate: 'Ativar modo parceiro',
        },
        api: {
          openAiTitle: 'OpenAI',
          openAiDescription: 'Configure sua chave de API para usar o nó OpenAI nos seus fluxos',
          geminiTitle: 'Google Gemini',
          geminiDescription: 'Configure sua chave de API para usar modelos Gemini nos seus fluxos',
          keyConfigured: 'Chave configurada',
          replaceKey: 'Substituir chave',
          apiKeyLabel: 'Chave de API',
          keySecureHelp: 'Sua chave é criptografada e armazenada com segurança',
          updateKey: 'Atualizar Chave',
          saveKey: 'Salvar Chave',
          getKey: 'Obter Chave',
        },
        billing: {
          title: 'Plano Atual',
          description: 'Gerencie seu plano de assinatura',
          partnerTitle: 'Plano de parceiro',
          partnerDescription: 'Este tenant opera com licença de parceiro e não depende de cobrança padrão nesta área.',
          partnerPlan: 'Plano de parceiro',
          partnerPlanHelper: 'Licença de parceiro ativa',
          partnerBadge: 'PARCEIRO',
          monthlyPlan: 'Plano Mensal',
          trialTitle: 'Período de Teste Gratuito',
          trialDescription: 'Você tem {{count}} dias restantes no seu período de teste. Aproveite todos os recursos premium gratuitamente.',
        },
        notifications: {
          title: 'Preferências de Notificação',
          description: 'Configure como você deseja receber notificações',
          errorAlertsTitle: 'Alertas de erro',
          errorAlertsDescription: 'Receba alertas quando um bot encontrar erros',
          testButton: 'Testar',
          connectionLostTitle: 'Conexão perdida',
          connectionLostDescription: 'Notificação quando uma conexão Bitrix24 for perdida',
          weeklyReportTitle: 'Relatório semanal',
          weeklyReportDescription: 'Resumo semanal de atividades dos bots',
          savePreferences: 'Salvar Preferências',
        },
        marketing: {
          title: 'Captura de Marketing',
          description: 'Capture códigos que o cliente enviar em qualquer momento da conversa e atualize origem + UTM no CRM',
          howItWorksTitle: 'Como funciona:',
          howItWorksBody: 'quando o cliente enviar uma mensagem com um código cadastrado abaixo, o sistema busca automaticamente pelo telefone do cliente e atualiza UTMs no Lead ou no Negócio.',
          howItWorksFields: 'Os campos padrão usados são:',
          enableTitle: 'Ativar captura de marketing',
          enableDescription: 'Lê códigos em toda nova mensagem do cliente',
          matchType: 'Tipo de leitura do código',
          matchContains: 'Contém o código na mensagem',
          matchExact: 'Mensagem igual ao código',
          rulesTitle: 'Códigos cadastrados',
          addRule: 'Adicionar regra',
          noRules: 'Nenhuma regra cadastrada.',
          targetEntity: 'Buscar este código em',
          lead: 'Lead',
          deal: 'Negócio',
          ruleCode: 'Código ou palavra',
          utmSource: 'UTM Source',
          utmMedium: 'UTM Medium',
          utmCampaign: 'UTM Campaign',
          utmContent: 'UTM Content',
          utmTerm: 'UTM Term',
          dealPipelineLabel: 'Pipeline do Negócio para este código',
          allPipelines: 'Todos os pipelines',
          pipelineFallback: 'Pipeline {{id}}',
          removeRule: 'Remover',
          save: 'Salvar',
        },
      },
      sidebar: {
        navigation: {
          dashboard: 'Dashboard',
          connections: 'Conexões',
          bots: 'Bots',
          flows: 'Fluxos',
          plans: 'Planos',
          settings: 'Configurações',
        },
        partnerPlansManagedTitle: 'Plano gerenciado por parceiro',
        partnerPlansManagedDescription:
          'Este ambiente está vinculado a um parceiro. Verifique com o parceiro responsável para contratar ou ajustar o plano.',
        close: 'Fechar',
        comingSoon: 'Em breve',
        docs: 'Documentação',
      },
    },
  },
  en: {
    translation: {
      subscription: {
        toasts: {
          loadPlansError: 'Unable to load subscription plans.',
          paymentConfirmed: 'Payment confirmed successfully!',
          paymentReleased: 'Payment confirmed! Your access has been restored.',
          paymentReturnReceived:
            'We received your payment return. Please refresh the page in a few seconds.',
          checkoutStartError: 'Unable to start checkout.',
          openPortalError: 'Unable to open the subscription portal.',
        },
        browserBlockedPrompt: 'Your browser blocked the new tab. Open this link manually:',
        successScreen: {
          title: 'Payment confirmed!',
          syncing: 'We are enabling your access...',
          redirecting: 'Your plan was activated successfully. Redirecting you to the dashboard.',
        },
        header: {
          partnerContactTitle: 'Contact your partner to restore access',
          paymentPendingTitle: 'Your access is temporarily paused',
          expiredTitle: 'Your trial has expired',
          defaultTitle: 'Choose the ideal plan for your business',
          partnerContactDescription:
            'This environment is managed by a partner. License purchase/renewal must be handled by the responsible partner.',
          paymentPendingDescription:
            'We detected a pending subscription payment. Regularize it now to reactivate the system immediately.',
          trialDescription: 'You have {{count}} days left in your 8-day trial period.',
          defaultDescription: 'Unlock the system and manage your subscription with Stripe.',
        },
        partnerContact: {
          title: 'License managed by partner',
          description:
            'Contact your partner to purchase or regularize the license for this environment.',
          partnerLabel: 'Partner:',
          partnerFallback: 'Responsible partner',
          contactLabel: 'Contact:',
          contactFallback: 'Not provided',
          action: 'Contact partner',
        },
        pendingCard: {
          description: 'As soon as payment is confirmed, your access is automatically restored.',
        },
        activeCard: {
          syncing: 'Confirming payment and restoring your access...',
          active: 'Payment confirmed successfully! Your access is active.',
        },
        actions: {
          back: 'Back',
          backToHome: 'Back to home',
          manageSubscription: 'Manage subscription',
        },
        partnerManaged: {
          title: 'Subscription managed by partner',
          description:
            'This environment is linked to a partner. Renewal and billing are handled directly by the responsible partner.',
          hidePlansMessage: 'Plans and pricing are available only to the partner responsible for this environment.',
          modalTitle: 'Check with your partner',
          modalDescription:
            'This environment is handled by a partner. Please contact the responsible partner to purchase or change the plan.',
          modalClose: 'Close',
        },
        partnerTenantUnavailable: 'Partners use the partner plan and do not purchase plans through this page.',
        plans: {
          loading: 'Loading plans...',
          empty: 'No plans configured. Set Stripe Price IDs in the backend.',
          popular: 'Most Popular',
          currentPlanBadge: 'Current plan',
          period: '/month',
          subscribeButton: 'Subscribe with Stripe',
          currentPlanButton: 'Your current plan',
          upgradeButton: 'Upgrade',
          downgradeNotAvailableButton: 'Lower plan',
          partnerManagedButton: 'Check with partner',
          addonLockedButton: 'Requires 2 bots',
          addonExtraBot: 'Adds 1 extra bot to your environment',
          addonMonthlyBilling: 'Monthly billing per additional bot',
          addonLockedRequirement:
            'To purchase 3 or more bots, this environment must first have at least 2 active bots.',
          unlimitedMessages: 'Unlimited messages',
          bitrixIntegration: 'Bitrix24 integration',
          visualFlowBuilder: 'Visual flow builder',
          includedBots_one: '{{count}} bot included',
          includedBots_other: '{{count}} bots included',
        },
        support: {
          prompt: 'Need help choosing?',
          action: 'Talk to our team',
        },
      },
      connections: {
        errors: {
          loadPartnerClients: 'Failed to load partner clients.',
          reconnectFailed: 'Unable to fix the connection.',
          linkClientFailed: 'Failed to link client.',
          unlinkClientFailed: 'Failed to unlink client.',
          openLicensePortalFailed: 'Failed to open license management.',
          noPlanAvailable: 'No plan available for hiring at the moment.',
          contractLicenseFailed: 'Failed to start license purchase.',
          openClientReadOnlyFailed: 'Unable to open client tenant in read-only mode.',
          backToPartnerFailed: 'Unable to return to partner dashboard.',
        },
        toasts: {
          reconnectSuccess: 'Connection fixed successfully.',
          linkClientSuccess: 'Link request sent for client approval.',
          readOnlyEnabled: 'Read-only mode enabled for the client tenant.',
          backToPartnerSuccess: 'Returned to partner dashboard.',
        },
        prompts: {
          blockedNewTabManage:
            'Your browser blocked the new tab. Open this link to manage/cancel the Stripe license:',
          blockedNewTabContract:
            'Your browser blocked the new tab. Open this link to purchase the Stripe license:',
        },
        status: {
          active: 'Active',
          pending: 'Pending',
          error: 'Error',
          disconnected: 'Disconnected',
          trial: 'Trial',
          expired: 'Expired',
          suspended: 'Suspended',
          cancelled: 'Cancelled',
        },
        partner: {
          title: 'Partner Area',
          subtitle: 'Manage linked clients and access their environment.',
          panelTitle: 'Partner Dashboard (view-only)',
          panelDescription:
            'Here you can view linked clients, access license cancellation, and enter client tenant in read-only mode.',
          domainLabel: 'Client domain in Bitrix24',
          domainPlaceholder: 'e.g.: client.bitrix24.com',
          linking: 'Linking...',
          linkClient: 'Link client',
          loadingClients: 'Loading partner clients...',
          noClientsTitle: 'No linked clients',
          noClientsDescription: 'Link a client Bitrix24 domain to start managing it.',
          noMainDomain: 'No primary domain detected',
          plan: 'Plan:',
          stripeStatus: 'Stripe status:',
          botLimit: 'Bot limit:',
          contactEmail: 'Technical contact:',
          na: 'n/a',
          customerAlreadyLicensed: 'Client already has an active license',
          openStripeCheckout: 'Open Stripe to purchase license',
          selectLicensePlan: 'Choose a license/plan for this client',
          selectLicensePlanModalTitle: 'Choose the license to purchase',
          selectLicensePlanModalDescription: 'Select the plan for {{client}} before opening checkout.',
          modalCancel: 'Cancel',
          modalConfirmPurchase: 'Continue to payment',
          openingCheckout: 'Opening checkout...',
          contractLicense: 'Purchase license',
          openStripePortal: 'Open Stripe to manage/cancel license',
          noLicenseToCancel: 'No active license to cancel',
          openingPortal: 'Opening portal...',
          cancelLicense: 'Cancel license',
          manage: 'Manage',
          managePlan: 'Manage plan',
          managePayment: 'Update payment (Stripe)',
          managePaymentHint: 'Open the Stripe portal to update the payment method, view invoices and manage the subscription',
          enteringReadOnly: 'Entering...',
          enterReadOnly: 'Enter (read-only)',
          updateContact: 'Update contact',
          updatingContact: 'Updating...',
          contactPrompt: 'Enter the client technical contact email:',
          contactEmptyError: 'Provide a valid contact email.',
          contactUpdated: 'Contact email updated successfully.',
          contactUpdateFailed: 'Failed to update client contact email.',
          unlinking: 'Unlinking...',
          unlink: 'Unlink',
          actingAsClient: 'You are viewing a linked client environment.',
          backToPartner: 'Back to partner dashboard',
        },
        defaultView: {
          title: 'Bitrix24 Connections',
          subtitle: 'Manage connections with your Bitrix24 portals',
          infoTitle: 'How does it work?',
          infoDescription:
            'Connections are created automatically when you install the app in a Bitrix24 portal. Each connection allows creating bots for that portal. To avoid interruptions, connection removal is not available to users.',
          noConnectionsTitle: 'No connections found',
          noConnectionsDescription:
            'Install the app in a Bitrix24 portal to create your first connection.',
          marketplaceButton: 'Go to Bitrix24 Marketplace',
          lastErrorPrefix: 'Last error:',
          botsCount_one: '{{count}} bot',
          botsCount_other: '{{count}} bots',
          connectedAt: 'Connected on {{date}}',
          fixConnection: 'Fix connection',
          renewApp: 'Renew app',
          botsInConnection: 'Bots in this connection:',
        },
      },
      flowBuilder: {
        readOnlyBanner: 'Read-only mode active: flow editing is disabled in this tenant.',
        defaults: {
          save: 'Save',
          publish: 'Publish',
          newFlow: 'New Flow',
          defaultFlowName: 'New Flow',
          defaultFlowDescription: 'Created via Dashboard',
          unsaved: 'Unsaved',
          addNode: 'Add Node',
        },
        states: {
          error: 'Error!',
          chooseMode: 'Choose mode',
          saved: 'Saved!',
          saveError: 'Save error',
          published: 'Published!',
        },
        executionMode: {
          label: 'Bot mode:',
          freeConversation: 'Free conversation',
          stepByStep: 'Step by step',
          modalTitle: 'How should the bot talk?',
          modalRequiredDescription: 'Choose a mode to continue configuring this flow.',
          modalOptionalDescription: 'You can change this mode whenever you want.',
          conventionalTitle: '🧭 Step by step',
          conventionalDescription: 'The bot follows a sequence and does not restart on each message.',
          continuousTitle: '💬 Free conversation',
          continuousDescription: 'Each new message restarts at the beginning of the flow to answer.',
          groupingTitle: 'Message grouping',
          groupingDescription: 'Waits for new messages for a few seconds and answers them together.',
          groupingEnableLabel: 'Enable grouping in this flow',
          groupingWindowLabel: 'Wait for',
          groupingWindowHint: 'If another message arrives in this window, it is merged into the same block.',
          groupingSeconds: 'seconds',
          functionCallingTitle: 'Global Function Calling (AI)',
          functionCallingDescription: 'Enables CRM tools for all AI nodes in this flow that use OpenAI.',
          functionCallingEnableLabel: 'Enable function calling in this flow',
          functionCallingMaxLabel: 'Max calls per execution:',
          functionCallingToolsLabel: 'Allowed tools',
          functionCallingVariableLabel: 'Save executions to variable (optional)',
          functionCallingVariablePlaceholder: 'Ex: ai_tool_executions',
          functionCallingVariableHint: 'If filled, stores the tool-call log for downstream nodes.',
          close: 'Close',
          confirm: 'Confirm',
        },
        nodeLabels: {
          START: 'Start',
          SEND_MESSAGE: 'Send Message',
          SEND_BUTTONS: 'Question',
          WAIT_INPUT: 'Wait Input',
          CONDITION: 'Condition',
          MESSAGE_TYPE: 'Message Type',
          DELAY: 'Delay',
          AI_RESPONSE: 'AI',
          HTTP_REQUEST: 'HTTP Request',
          TRANSFER_TO_OPERATOR: 'Transfer to Operator',
          END_SESSION: 'End Session',
          SET_VARIABLE: 'Set Variable',
          PARSE_JSON: 'JSON Parser',
          ADD_TAG: 'Marketing Capture',
          CREATE_LEAD: 'Create Lead',
          CREATE_COMPANY: 'Create Company',
          CREATE_CONTACT: 'Create Contact',
          CREATE_DEAL: 'Create Deal',
          GET_CRM_ENTITY: 'Get CRM',
          UPDATE_CONTACT: 'Edit CRM',
          MOVE_DEAL_STAGE: 'Move Stage/Pipeline',
        },
      },
      settings: {
        page: {
          title: 'Settings',
          subtitle: 'Manage your account settings',
          readOnlyBanner: 'Read-only mode active: settings changes are disabled in this tenant.',
        },
        tabs: {
          general: 'General',
          api: 'Integrations',
          billing: 'Plan & Billing',
          notifications: 'Notifications',
          marketing: 'Marketing',
        },
        toasts: {
          invalidEmail: 'Enter a valid email for the technical owner.',
          invalidEmailTitle: 'Invalid email',
          saveSuccess: 'Settings saved successfully!',
          savedTitle: 'Saved',
          saveError: 'Could not save changes.',
          saveErrorTitle: 'Save error',
          testNotificationSuccess: 'Test notification sent! Check the Bitrix24 bell.',
          testNotificationSuccessTitle: 'Success',
          testNotificationErrorTitle: 'Failed to send notification',
          invalidOpenAiKey: 'The key must start with "sk-"',
          invalidOpenAiKeyTitle: 'Invalid key',
          openAiKeySaved: 'OpenAI key saved successfully!',
          openAiKeyRemoved: 'OpenAI key removed.',
          geminiKeySaved: 'Gemini key saved successfully!',
          geminiKeyRemoved: 'Gemini key removed.',
          keyErrorTitle: 'Error saving key',
          keyRemoveErrorTitle: 'Error removing key',
          partnerActivated: 'Account activated in partner program!',
          partnerActivatedTitle: 'Partner activated',
          invalidPartnerCodeTitle: 'Invalid code',
          languageUpdated: 'Language updated successfully!',
          languageTitle: 'Language',
          languageUpdateError: 'Could not change language.',
        },
        general: {
          accountTitle: 'Account Information',
          accountDescription: 'Basic account information',
          companyName: 'Company Name',
          technicalEmail: 'Technical owner email',
          technicalEmailPlaceholder: 'tech@company.com',
          technicalEmailHelper: 'This email is used as the technical contact reference.',
          accountStatus: 'Account Status',
          statusActive: 'Active',
          statusTrial: 'Trial',
          statusExpired: 'Expired',
          statusPending: 'Pending',
          languageLabel: 'Platform language',
          languageHelp: 'The change is applied immediately and saved in this browser.',
          languagePtBr: 'Português (Brasil)',
          languageEn: 'English',
          saveInfo: 'Save Information',
        },
        partner: {
          title: 'Partner Program',
          description: 'Enable partner mode to manage linked clients in the Connections menu.',
          alreadyPartner: 'Account is already enabled as partner.',
          codeLabel: 'Partner code',
          codePlaceholder: 'Ex.: PARTNER-2026',
          codeHelp: 'Use the code you received to unlock the partner dashboard.',
          activate: 'Enable partner mode',
        },
        api: {
          openAiTitle: 'OpenAI',
          openAiDescription: 'Set your API key to use the OpenAI node in your flows',
          geminiTitle: 'Google Gemini',
          geminiDescription: 'Set your API key to use Gemini models in your flows',
          keyConfigured: 'Key configured',
          replaceKey: 'Replace key',
          apiKeyLabel: 'API key',
          keySecureHelp: 'Your key is encrypted and stored securely',
          updateKey: 'Update Key',
          saveKey: 'Save Key',
          getKey: 'Get Key',
        },
        billing: {
          title: 'Current Plan',
          description: 'Manage your subscription plan',
          partnerTitle: 'Partner plan',
          partnerDescription: 'This tenant runs under a partner license and does not rely on standard billing in this area.',
          partnerPlan: 'Partner plan',
          partnerPlanHelper: 'Active partner license',
          partnerBadge: 'PARTNER',
          monthlyPlan: 'Monthly Plan',
          trialTitle: 'Free Trial Period',
          trialDescription: 'You have {{count}} days left in your trial period. Enjoy all premium features for free.',
        },
        notifications: {
          title: 'Notification Preferences',
          description: 'Configure how you want to receive notifications',
          errorAlertsTitle: 'Error alerts',
          errorAlertsDescription: 'Receive alerts when a bot encounters errors',
          testButton: 'Test',
          connectionLostTitle: 'Connection lost',
          connectionLostDescription: 'Notification when a Bitrix24 connection is lost',
          weeklyReportTitle: 'Weekly report',
          weeklyReportDescription: 'Weekly summary of bot activity',
          savePreferences: 'Save Preferences',
        },
        marketing: {
          title: 'Marketing Capture',
          description: 'Capture codes sent by the client at any point in the conversation and update source + UTM in CRM',
          howItWorksTitle: 'How it works:',
          howItWorksBody: 'when the client sends a message with a code registered below, the system automatically searches by client phone and updates UTMs in Lead or Deal.',
          howItWorksFields: 'The default fields used are:',
          enableTitle: 'Enable marketing capture',
          enableDescription: 'Reads codes in every new client message',
          matchType: 'Code reading type',
          matchContains: 'Message contains the code',
          matchExact: 'Message equals the code',
          rulesTitle: 'Registered codes',
          addRule: 'Add rule',
          noRules: 'No rules registered.',
          targetEntity: 'Search this code in',
          lead: 'Lead',
          deal: 'Deal',
          ruleCode: 'Code or keyword',
          utmSource: 'UTM Source',
          utmMedium: 'UTM Medium',
          utmCampaign: 'UTM Campaign',
          utmContent: 'UTM Content',
          utmTerm: 'UTM Term',
          dealPipelineLabel: 'Deal pipeline for this code',
          allPipelines: 'All pipelines',
          pipelineFallback: 'Pipeline {{id}}',
          removeRule: 'Remove',
          save: 'Save',
        },
      },
      sidebar: {
        navigation: {
          dashboard: 'Dashboard',
          connections: 'Connections',
          bots: 'Bots',
          flows: 'Flows',
          plans: 'Plans',
          settings: 'Settings',
        },
        partnerPlansManagedTitle: 'Plan managed by partner',
        partnerPlansManagedDescription:
          'This environment is linked to a partner. Check with the responsible partner to purchase or adjust the plan.',
        close: 'Close',
        comingSoon: 'Coming soon',
        docs: 'Documentation',
      },
    },
  },
} as const;

export type AppLanguage = keyof typeof resources;
